import React from "react";
import { motion } from "framer-motion";
import BulletPoint from "./BulletPoint.jsx";

const Packt = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: 0.1 }}
      className="w-full"
    >
      {/* JOB TITLE & COMPANY */}
      <div className="flex text-white flex-wrap gap-1 font-medium text-xl font-titleFont flex-col sml:flex-row">
        <h3>Technical Reviewer</h3>
        <a
          href="https://www.amazon.in/Node-js-Beginners-comprehensive-full-featured-applications/dp/1803245174"
          target="_blank"
        >
          <span className="text-sm mt-1 font-medium text-textGreen flex">
            @Packt Publishing
          </span>
        </a>
      </div>
      {/* Working Dates */}
      <p className="pt-3 text-white">Feb 2024 - Mar 2024</p>
      {/* INTRODUCTION */}
      <p className="mt-3 text-base font-light flex gap-2 text-textDark">
        <strong>
          Actively reviewed a comprehensive Node.js book covering beginner to
          advanced topics. Focused on enhancing the material by integrating
          practical suggestions and relevant real-world examples.
        </strong>
      </p>
      {/* Bullet Points */}
      <ul className="mt-4 flex flex-col gap-3 text-textDark">
        <BulletPoint
          headningText="Complex Topic Elucidation"
          contentText="Delved into explaining intricate concepts such as error handling and
      event emitting, ensuring the content is accessible and understandable for
      readers of all levels."
        />
      </ul>
    </motion.div>
  );
};

export default Packt;
